import { render, staticRenderFns } from "./sp-top-part.vue?vue&type=template&id=15699b87"
import script from "./sp-top-part.vue?vue&type=script&lang=js"
export * from "./sp-top-part.vue?vue&type=script&lang=js"
import style0 from "./sp-top-part.vue?vue&type=style&index=0&id=15699b87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports